import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Button, Modal, Tooltip } from '@mui/material';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import IosShareIcon from '@mui/icons-material/IosShare';
import Aside from 'src/components/Aside';
import Logo from 'src/components/Items/Logo';
import LoginModal from './LoginModal';
import ShareModal from '../Items/ShareModal';
import GeneralFilter from 'src/components/Items/Filters/General';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { useActions } from 'src/hooks/useActions';
import './styles.scss';
import './media.scss';

interface IProps {
  marginTop: number;
  setMarginTop: (arg0: number) => void;
}

const Header: FC<IProps> = ({ marginTop, setMarginTop }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { clearClientResult } = useActions();
  const { isLogin, result, isError } = useTypedSelector(state => state.client);
  const [open, setOpen] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const location = window.location.href;

  useEffect(() => {
    isLogin && result.login && navigate('/client');
  }, [isLogin, result]);

  useEffect(() => {
    isError &&
      (localStorage.removeItem('guest-token'),
      setOpenLogin(true),
      enqueueSnackbar('Your password has expired. Please login again', {
        variant: 'info'
      }),
      clearClientResult());
  }, [isError]);

  const handleOpen = () => {
    isLogin ? navigate('/client') : setOpenLogin(true);
  };

  return (
    <>
      <div className={`header__wrapper`}>
        <div className='header__wrapper_sup'>
          <div className='header__container'>
            <Logo />
            <div className='header__mobile_icon-set'>
              <Button variant='contained' onClick={handleOpen} children='My booking' />
            </div>
            <div className='header__container__mobile-filters'>
              <Tooltip title='Share searched URL'>
                <IosShareIcon onClick={() => setOpenShare(true)} sx={{ cursor: 'pointer' }} />
              </Tooltip>
              <div
                className='header__container__mobile-filters__filter'
                onClick={() => setOpen(true)}
              >
                <TuneOutlinedIcon sx={{ fontSize: 27 }} />
                <span>Filters</span>
              </div>
            </div>
          </div>
          <GeneralFilter marginTop={marginTop} setMarginTop={setMarginTop} />
          <div className='header__icon-set'>
            <Tooltip title='Share searched URL'>
              <IosShareIcon onClick={() => setOpenShare(true)} sx={{ cursor: 'pointer' }} />
            </Tooltip>
            <Button variant='contained' onClick={handleOpen} children='My booking' />
          </div>
        </div>
        <Modal open={open} onClose={() => setOpen(false)} closeAfterTransition>
          <>
            <Aside handleClose={() => setOpen(false)} />
          </>
        </Modal>
        <LoginModal open={openLogin} onClose={() => setOpenLogin(false)} />
        <ShareModal
          url={location}
          open={openShare}
          onClose={() => setOpenShare(false)}
          className='on-header'
        />
      </div>
    </>
  );
};

export default Header;
